import { GlButton, GlEmptyState, GlIcon, GlLink, GlLoadingIcon, GlTableLite, GlTruncate, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../alert.js?vue3';
import { __, s__, sprintf } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import { scrollToElement } from '~/lib/utils/scroll_utils';
import HelpIcon from '../../../../vue_shared/components/help_icon/help_icon.vue?vue3';
import PageNavigationMenu from '~/vue_shared/components/page_navigation_menu.vue';
import getCiCatalogResourceComponents from '../../graphql/queries/get_ci_catalog_resource_components.query.graphql';
export default {
    name: 'CiResourceComponents',
    components: {
        GlButton,
        GlEmptyState,
        GlIcon,
        GlLink,
        GlLoadingIcon,
        GlTableLite,
        GlTruncate,
        HelpIcon,
        PageNavigationMenu
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inputHelpLink: helpPagePath('ci/inputs/_index.md', {
        anchor: 'define-input-parameters-with-specinputs'
    }),
    props: {
        resourcePath: {
            type: String,
            required: true
        },
        version: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            components: []
        };
    },
    apollo: {
        components: {
            query: getCiCatalogResourceComponents,
            variables () {
                return {
                    fullPath: this.resourcePath,
                    version: this.version
                };
            },
            update (data) {
                return data?.ciCatalogResource?.versions?.nodes[0]?.components?.nodes || [];
            },
            error () {
                createAlert({
                    message: this.$options.i18n.fetchError
                });
            },
            result () {
                this.$nextTick(()=>{
                    if (window.location.hash) {
                        const componentName = decodeURIComponent(window.location.hash.substring(1));
                        this.scrollToComponent(componentName);
                    }
                });
            }
        }
    },
    computed: {
        isMetadataMissing () {
            return !this.components || this.components?.length === 0;
        },
        isLoading () {
            return this.$apollo.queries.components.loading;
        },
        navigationItems () {
            return this.components.map((component)=>({
                    id: encodeURIComponent(component.name),
                    label: component.name
                }));
        }
    },
    methods: {
        generateSnippet (componentPath) {
            // This is not to be translated because it is our CI yaml syntax.
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `include:
  - component: ${componentPath}`;
        },
        getItemValue (item) {
            return String(item.default);
        },
        shouldShowCodeBlock (item) {
            return item.default && item.type === 'ARRAY';
        },
        getCodeBlock (item) {
            try {
                return JSON.stringify(item.default, null, 2);
            } catch (e) {
                return String(item.default);
            }
        },
        getComponentLabel (componentName) {
            return sprintf(s__('CiCatalogComponent|Link to %{componentName}'), {
                componentName
            });
        },
        scrollToComponent (componentName) {
            const hash = `#${encodeURIComponent(componentName)}`;
            window.history.pushState(null, '', hash);
            const element = document.getElementById(encodeURIComponent(componentName));
            if (element) {
                scrollToElement(element, {
                    behavior: 'smooth'
                });
            }
        }
    },
    fields: [
        {
            key: 'name',
            label: s__('CiCatalogComponent|Name')
        },
        {
            key: 'required',
            label: s__('CiCatalogComponent|Mandatory'),
            class: '@md/panel:gl-w-15'
        },
        {
            key: 'type',
            label: s__('CiCatalogComponent|Type'),
            class: '@md/panel:gl-w-15'
        },
        {
            key: 'description',
            label: s__('CiCatalogComponent|Description')
        },
        {
            key: 'default',
            label: s__('CiCatalogComponent|Default')
        }
    ],
    i18n: {
        emptyStateTitle: s__('CiCatalogComponent|Component details not available'),
        emptyStateDesc: s__('CiCatalogComponent|This tab displays auto-collected information about the components in the repository, but no information was found.'),
        fetchError: s__("CiCatalogComponent|There was an error fetching this resource's components"),
        inputTitle: s__('CiCatalogComponent|Inputs'),
        learnMore: __('Learn more')
    }
};
